import { render, staticRenderFns } from "./AumentoGeneral.vue?vue&type=template&id=46ab3c9e&scoped=true&"
import script from "./AumentoGeneral.vue?vue&type=script&lang=js&"
export * from "./AumentoGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ab3c9e",
  null
  
)

export default component.exports